import KwataniScreen1D from './MultislopeScreenKM1D.png';
import KwataniScreen2D from './MultislopeScreenKM2D.png';
import KwataniScreen1D2 from './MultislopeScreenKM1D_2.png';
import KwataniScreen2D2 from './MultislopeScreenKM2D_2.png';

export const getImageKwataniScreen = (nbrOfDecks: number) => {
  if (nbrOfDecks === 2) {
    return KwataniScreen2D;
  } else {
    return KwataniScreen1D;
  }
};

export const getImageKwataniScreen2 = (nbrOfDecks: number) => {
  if (nbrOfDecks === 2) {
    return KwataniScreen2D2;
  } else {
    return KwataniScreen1D2;
  }
};
